<script lang="ts">
  import ComparisonTable from '$lib/components/ComparisonTable.svelte';
  import GridLines from '$lib/components/GridLines.svelte';
  import GridContent from '$lib/components/GridContent.svelte';
  import GridInner from '$lib/components/GridInner.svelte';
  import Star from '$lib/components/Star.svelte';
  import { hatchStyle45 } from '$lib/styles/hatch';

  // Landing page runs the compact 4-row version.
  // /why-corral runs the 7-row expansion of the same argument.
  const rows = [
    { label: 'Cost',     si: '$500K – $2M+',                                internal: '$500K – $1M+ in eng time',           corral: 'Platform subscription' },
    { label: 'Timeline', si: '6 – 12 months',                                internal: '6 – 12 months',                       corral: '30 minutes to deploy' },
    { label: 'Outcome',  si: 'Someone else\u2019s vision of your AI.',       internal: '6-12 months before you make it yours.', corral: 'Start shaping AI on day one.' },
    { label: 'Week 2',   si: 'Still in procurement.',                        internal: 'Still building auth.',                corral: 'Building agents for your workflows.' },
  ];
</script>

<section id="three-paths" class="bg-[#f9f9f4] relative" style={hatchStyle45}>
  <GridLines variant="light" />

  <GridContent>
    <GridInner>
      <div class="py-[80px] lg:py-[110px]">
        <!-- Header -->
        <div class="flex flex-col items-start lg:items-center text-left lg:text-center mb-12 lg:mb-14 max-w-[780px] mx-auto">
          <p class="font-mono text-[12px] uppercase tracking-[0.12em] text-[#ee6018] mb-5">
            03 · Three Paths
          </p>
          <h2 class="font-display font-[300] text-[40px] md:text-[52px] lg:text-[60px] leading-[1.02] tracking-[-0.035em] text-[#020202] mb-5">
            Three ways to make AI yours. Only one that works.
          </h2>
          <p class="font-body font-light text-[16px] lg:text-[18px] leading-[1.55] text-[#5C5855] max-w-[620px]">
            Build it yourself, pay someone $500K+ to build it for you, or deploy a foundation that's already built — and start shaping it to your business on day one.
          </p>
        </div>

        <!-- Comparison table -->
        <div class="relative">
          <!-- Line across the top of the card -->
          <div class="hidden lg:block absolute top-0 -left-[calc(54px+9.03vw)] -right-[calc(54px+9.03vw)] h-px bg-[#D3D3D3] z-[5]" aria-hidden="true"></div>
          <Star variant="full" color="#D3D3D3" class="hidden lg:block absolute -left-[63px] top-[-9px]" />
          <Star variant="full" color="#D3D3D3" class="hidden lg:block absolute -right-[63px] top-[-9px]" />

          <!-- Line across the bottom of the card -->
          <div class="hidden lg:block absolute bottom-0 -left-[calc(54px+9.03vw)] -right-[calc(54px+9.03vw)] h-px bg-[#D3D3D3] z-[5]" aria-hidden="true"></div>
          <Star variant="full" color="#D3D3D3" class="hidden lg:block absolute -left-[63px] bottom-[-9px]" />
          <Star variant="full" color="#D3D3D3" class="hidden lg:block absolute -right-[63px] bottom-[-9px]" />

          <div class="bg-white border border-[#D3D3D3] p-6 lg:p-8 relative">
            <Star variant="bottom" color="#D3D3D3" class="hidden lg:block absolute -left-[10px] -top-[1px]" />
            <Star variant="bottom" color="#D3D3D3" class="hidden lg:block absolute -right-[10px] -top-[1px]" />
            <Star variant="top" color="#D3D3D3" class="hidden lg:block absolute -left-[10px] -bottom-px" />
            <Star variant="top" color="#D3D3D3" class="hidden lg:block absolute -right-[10px] -bottom-px" />

            <ComparisonTable {rows} variant="light" />
          </div>
        </div>

        <!-- Inline mid-page CTA (per marketing polish plan) -->
        <div class="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6 mt-14 lg:mt-16 max-w-[900px] mx-auto">
          <p class="font-body font-light text-[16px] lg:text-[17px] leading-[1.5] text-[#282828] max-w-[480px]">
            If your engineers would rather ship the AI that makes your business unique than rebuild the seven layers everyone else is rebuilding — keep reading. Or skip ahead.
          </p>
          <div class="flex items-center gap-5 shrink-0">
            <a
              href="https://azuremarketplace.microsoft.com"
              class="bg-black text-white font-mono text-[13px] h-[44px] px-6 flex items-center justify-center hover:bg-[#1a1a1a] transition-colors"
              style="box-shadow: 0px 0px 14.7px 5px rgba(255, 255, 255, 0.35) inset;"
            >
              Deploy on Azure
            </a>
            <a
              href="/why-corral"
              class="font-mono text-[13px] text-[#5C5855] hover:text-[#020202] inline-flex items-center gap-1.5 transition-colors"
            >
              Read the full thesis <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </div>
    </GridInner>
  </GridContent>
</section>
